import { createReducer, on } from '@ngrx/store';

import { OrderActions, SeatMapActions, ServicesActions } from '@fcom/common-booking/store';

import { MmbStage } from '../../enums';
import { StateActions } from '../actions';
import { StatusState } from '../../interfaces/store.interface';

export const initialState: StatusState = {
  loading: false,
  error: null,
  stage: MmbStage.LOGIN,
  servicesDirty: false,
};

const stateReducer = createReducer(
  initialState,
  on(
    SeatMapActions.setSeatForFlight,
    ServicesActions.setSelectionsForFragment,
    ServicesActions.setSelectionForFragmentForTraveler,
    ServicesActions.removeAllPendingServices,
    (state) => ({
      ...state,
      servicesDirty: true,
    })
  ),
  on(OrderActions.resetCategoriesUpdating, OrderActions.clearCategoryUpdating, (state) => ({
    ...state,
    servicesDirty: false,
  })),
  on(SeatMapActions.resetSeatSelections, OrderActions.clearCategoryUpdating, (state) => ({
    ...state,
    servicesDirty: false,
  })),
  on(StateActions.setLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),
  on(StateActions.setError, (state, { error }) => ({
    ...state,
    error,
  })),
  on(StateActions.clearError, (state) => ({
    ...state,
    error: null,
  })),
  on(StateActions.setStage, (state, { stage }) => ({
    ...state,
    stage,
  })),
  on(StateActions.clearStatusState, () => initialState)
);

export function reducer(state: StatusState, action: StateActions.StateActionsUnion): StatusState {
  return stateReducer(state, action);
}
